// Enhance the existing translated merchant blocks without duplicating their content.
(() => {
  const selector = '[id$="__footer_Bg4B4a"] .footer-content';
  function enhance() {
    document.querySelectorAll(selector).forEach(footer => {
      footer.classList.add('nova-footer');
      footer.querySelectorAll(':scope > .group-block').forEach(group => {
        if (group.querySelector(':scope > details')) return;
        const content = group.querySelector(':scope > .group-block-content');
        const heading = content?.firstElementChild;
        if (!heading?.querySelector('h1,h2,h3,h4,h5,h6')) return;
        const details = document.createElement('details');
        const summary = document.createElement('summary');
        details.className = 'nova-footer__accordion';
        summary.className = 'nova-footer__summary';
        summary.append(heading);
        details.append(summary, content);
        group.append(details);
      });
    });
  }
  enhance();
  document.addEventListener('shopify:section:load', enhance);
  document.addEventListener('shopify:block:select', event => {
    event.target.closest('.nova-footer__accordion')?.setAttribute('open', '');
  });
  // A restored page should also start with the sections collapsed.
  window.addEventListener('pageshow', () => {
    document.querySelectorAll(selector + ' details').forEach(details => details.open = false);
  });
})();
